import React from "react";
import LegalLayout from "./LegalLayout";
import { Mail, MapPin, MessageCircle, Clock } from "lucide-react";

export default function Contact() {
  return (
    <LegalLayout title="Contact us">
      <p className="text-lg text-lm-text2 leading-relaxed max-w-2xl mb-10">
        We answer every email personally. Whether it's a billing question, a bug you've spotted,
        or a feature you want us to build - drop us a line and we'll come back within 24 business
        hours.
      </p>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-5 not-prose">
        <ContactCard
          icon={Mail}
          label="Talk to us"
          value="support@aifreedomclub.com"
          href="mailto:support@aifreedomclub.com"
        />
        <div className="rounded-lg border border-lm-border bg-lm-surface p-5 flex flex-col justify-center">
          <div className="text-xs font-mono uppercase tracking-widest text-lm-text3 mb-1.5">
            One inbox, one team
          </div>
          <p className="text-sm text-lm-text2 leading-relaxed">
            Support, billing, refunds, partnerships, data-protection - all handled from the same
            address. Mention the topic in your subject line and it'll reach the right person.
          </p>
        </div>
      </div>

      <div className="mt-10 rounded-lg border border-lm-border bg-lm-surface p-6 not-prose">
        <div className="flex items-start gap-4">
          <div className="w-10 h-10 rounded-md bg-lm-tint2 text-lm-primary flex items-center justify-center shrink-0">
            <MapPin className="w-4 h-4" />
          </div>
          <div className="flex-1">
            <div className="text-xs font-mono uppercase tracking-widest text-lm-text3 mb-1">
              Registered address
            </div>
            <div className="text-sm text-lm-text leading-relaxed">
              Leadmato
              <br />
              Kolkata, West Bengal 700060
              <br />
              India
            </div>
          </div>
        </div>
      </div>

      <div className="mt-4 rounded-lg border border-lm-border bg-lm-surface p-6 not-prose">
        <div className="flex items-start gap-4">
          <div className="w-10 h-10 rounded-md bg-lm-tint3 text-lm-secondary flex items-center justify-center shrink-0">
            <Clock className="w-4 h-4" />
          </div>
          <div className="flex-1">
            <div className="text-xs font-mono uppercase tracking-widest text-lm-text3 mb-1">
              Response time
            </div>
            <div className="text-sm text-lm-text leading-relaxed">
              Monday - Friday, 10:00 - 18:00 IST. Weekend replies for urgent billing or account
              issues. Expect a first response within 24 business hours.
            </div>
          </div>
        </div>
      </div>

      <div className="mt-10 not-prose">
        <div className="rounded-lg border-2 border-dashed border-lm-border p-6 flex items-start gap-3">
          <MessageCircle className="w-5 h-5 text-lm-primary shrink-0 mt-0.5" />
          <div className="text-sm text-lm-text2">
            <strong className="text-lm-text">Founder-first support.</strong> Every email is read
            and answered by the founding team - no ticket queues, no bots. We treat every message
            as feedback on the product.
          </div>
        </div>
      </div>
    </LegalLayout>
  );
}

function ContactCard({ icon: Icon, label, value, href }) {
  return (
    <a
      href={href}
      className="group rounded-lg border border-lm-border bg-lm-surface p-5 hover:border-lm-primary/40 hover:-translate-y-0.5 transition-all"
    >
      <div className="flex items-center gap-3 mb-2">
        <div className="w-9 h-9 rounded-md bg-lm-tint2 text-lm-primary flex items-center justify-center">
          <Icon className="w-4 h-4" strokeWidth={2.2} />
        </div>
        <div className="text-xs font-mono uppercase tracking-widest text-lm-text3">{label}</div>
      </div>
      <div className="text-base font-semibold text-lm-text group-hover:text-lm-primary transition-colors">
        {value}
      </div>
    </a>
  );
}
